import { checklistApi } from '@/services/checklistApi'
const qs = require('qs')

export function list(params) {
  return checklistApi.get('/web/dispute/list', {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })
}
